import { Routes, Route } from "react-router-dom"
import { Toaster, ToastBar, toast } from "react-hot-toast"
import ScrollToTop from "./components/ScrollToTop/ScrollToTop"

import routes from "./routes/routes"
import Main from "./pages/Main/Main"
import Home from "./pages/Home/Home"
import ModalBase from "./modals/ModalBase/ModalBase"

import NotFound from "./pages/NotFound/NotFound"
import Profile from "./pages/Profile/Profile"

import Auth from "./pages/auth/Auth/Auth"
import VerifyEmail from "./pages/auth/VerifyEmail/VerifyEmail"
import ForgotPassword from "./pages/auth/ForgotPassword/ForgotPassword"
import ChangePassword from "./pages/auth/ChangePassword/ChangePassword"
import ServiceSearch from "./pages/Services/Search/Search"
import ProviderServices from "./pages/Provider/Services/ProviderServices"
import ProviderRequests from "./pages/Provider/Requests/ProviderRequests"
import ProviderWallet from "./pages/Provider/Wallet/ProviderWallet"
import ProviderWithdrawal from "./pages/Provider/Withdrawal/ProviderWithdrawal"
import ProviderSelectServices from "./pages/Provider/SelectServices/ProviderSelectServices"
import ProviderAddOffering from "./pages/Provider/AddOffering/ProviderAddOffering"
import ProviderAddCertification from "./pages/Provider/AddCertification/ProviderAddCertification"
import ProviderConfigureProfile from "./pages/Provider/ConfigureProfile/ProviderConfigureProfile"
import ProviderVerificationStatus from "./pages/Provider/VerificationStatus/ProviderVerificationStatus"
import ProviderOfferingDetail from "./pages/Provider/OfferingDetail/ProviderOfferingDetail"
import ProviderQuoteDetail from "./pages/Provider/QuoteDetail/QuoteDetail"
import ProviderSetup from "./pages/Provider/Setup/ProviderSetup"
import Requests from "@/pages/Requests/Requests"
import RequestCreate from "./pages/Requests/Create/RequestCreate"
import RequestDetail from "./pages/Requests/Detail/RequestDetail"
import RequestConfirm from "./pages/Requests/Confirm/RequestConfirm"
import QuoteDetail from "./pages/Requests/QuoteDetail/QuoteDetail"
import PaymentUpload from "./pages/Payment/Upload/PaymentUpload"
import PaymentDetail from "./pages/Payment/Detail/PaymentDetail"
import ReviewDetail from "./pages/Review/Detail/ReviewDetail"
import ComplaintCreate from "./pages/Complaint/Create/ComplaintCreate"
import ChatDetail from "./pages/Chat/Detail/ChatDetail"
import ChatList from "./pages/Chat/List/ChatList"
import ProviderDetail from "./pages/Provider/Detail/ProviderDetail"
import ServiceDetail from "./pages/Services/Detail/ServiceDetail"

import './App.css'

function App() {
    // The new AuthStore no longer needs initialization as it
    // checks token validity on creation
    return (
        <div className="App">
            <ModalBase />
            <ScrollToTop />
            <Toaster
                position="top-center"
                toastOptions={{
                    duration: 5000,
                    success: { className: "toast-success" },
                    error: { className: "toast-error" },
                    style: {
                        zIndex: 20
                    }
                }}
                children={(toasts) => (
                    <ToastBar toast={toasts}>
                        {({ icon, message }) => (
                            <div
                              onClick={() => toast.dismiss()}
                              style={{ cursor: "pointer", display: "flex"}}
                            >
                                {icon}
                                {message}
                            </div>
                        )}
                    </ToastBar>
                )}
            />
            <Routes>
                {/* Auth endpoints */}
                <Route path={routes.auth} element={<Auth />} />
                <Route path={routes.verifyEmail} element={<VerifyEmail />} />
                <Route path={routes.forgotPassword} element={<ForgotPassword />} />
                <Route path={routes.changePassword} element={<ChangePassword />} />

                <Route path={routes.main} element={<Main />}>
                    <Route path={routes.home} element={<Home />} />
                    <Route path={routes.serviceSearch} element={<ServiceSearch />} />
                    <Route path={routes.providerServices} element={<ProviderServices />} />
                    <Route path={routes.providerRequests} element={<ProviderRequests />} />
                    <Route path={routes.providerWallet} element={<ProviderWallet />} />
                    <Route path={routes.providerWithdrawal} element={<ProviderWithdrawal />} />
                    <Route path={routes.providerSetup} element={<ProviderSetup />} />
                    <Route path={routes.providerSelectServices} element={<ProviderSelectServices />} />
                    <Route path={routes.providerAddOffering} element={<ProviderAddOffering />} />
                    <Route path={routes.providerAddCertification} element={<ProviderAddCertification />} />
                    <Route path={routes.providerConfigureProfile} element={<ProviderConfigureProfile />} />
                    <Route path={routes.providerVerificationStatus} element={<ProviderVerificationStatus />} />
                    <Route path={routes.providerOfferingDetail} element={<ProviderOfferingDetail />} />
                    <Route path={routes.providerQuoteDetail} element={<ProviderQuoteDetail />} />
                    
                    <Route path={routes.requests} element={<Requests />} />
                    <Route path={routes.requestCreate} element={<RequestCreate />} />
                    <Route path={routes.requestDetail} element={<RequestDetail />} />
                    <Route path={routes.requestConfirm} element={<RequestConfirm />} />
                    <Route path={routes.quoteDetail} element={<QuoteDetail />} />
                    <Route path={routes.paymentUpload} element={<PaymentUpload />} />
                    <Route path={routes.paymentUploadWithId} element={<PaymentUpload />} />
                    <Route path={routes.paymentDetail} element={<PaymentDetail />} />
                    <Route path={routes.reviewDetail} element={<ReviewDetail />} />
                    <Route path={routes.complaintCreate} element={<ComplaintCreate />} />
                    <Route path={routes.conversations} element={<ChatList />} />
                    <Route path={routes.chat} element={<ChatDetail />} />

                    <Route path={routes.providerDetail} element={<ProviderDetail />} />
                    <Route path={routes.serviceDetail} element={<ServiceDetail />} />
                    <Route path={routes.profile} element={<Profile />} />
                </Route>
                <Route path={routes.notFound} element={<NotFound />} />
            </Routes>
        </div>
    )
}

export default App
